import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import SL_Grid from '../../components/grid/SL_Grid';
import UserFilters from './UserFilters';
import { userGridColumns } from './grid_columns/user_grid_columns';
import api from '../../services/api';
import { displayMessage } from '../../helpers/messages';
import { showErrorMessage } from '../../services/messages';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import Divider from '../../components/divider/Divider';

const ListUsers = () => {
  const navigate = useNavigate();
  const { setShowLoading } = useContext(GeneralContext);

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    loadUsers(filters);
  }, []);

  const loadUsers = async (filterParams = {}) => {
    setLoading(true);
    try {
      // Envia os filtros diretamente para o backend
      const response = await api.user.list(filterParams);
      setUsers(response.data);
    } catch (error) {
      showErrorMessage(error?.response?.data?.error || displayMessage('ERROR_LOAD'));
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (values) => {
    setFilters(values);
    // Envia os filtros para o backend
    loadUsers(values);
  };

  const handleClearFilters = () => {
    setFilters({});
    // Recarrega sem filtros
    loadUsers({});
  };

  const handleEdit = (record) => {
    navigate(`/users/${record.id}`);
  };

  const handleCreate = () => {
    navigate('/users/new');
  };

  const columns = userGridColumns(handleEdit);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Card
        title={displayMessage('USERS')}
        extra={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleCreate}
          >
            {displayMessage('NEW_USER')}
          </Button>
        }
      >
        <UserFilters onFilter={handleFilter} onClear={handleClearFilters} />
        
        <Divider />

        <SL_Grid
          dataSource={users}
          columns={columns}
          loading={loading}
          rowKey="id"
        />
      </Card>
    </div>
  );
};

export default ListUsers;

